import { render, staticRenderFns } from "./OrdersDashboard.vue?vue&type=template&id=02f62650&scoped=true"
import script from "./OrdersDashboard.vue?vue&type=script&lang=js"
export * from "./OrdersDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f62650",
  null
  
)

export default component.exports